import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.2,18.5L13.5,3.8c0,0,0-0.1-0.1-0.1c-0.7-0.9-2.1-0.9-2.8,0c0,0,0,0.1-0.1,0.1L1.7,18.5c-0.3,0.5-0.3,1.1,0,1.7C2,20.7,2.6,21,3.2,21h17.6c0.6,0,1.2-0.4,1.5-1C22.6,19.5,22.6,18.9,22.2,18.5z M13,18h-2v-2h2V18z M13,14h-2V9h2V14z" })
});
export default SvgError;
